<template>
  <div class="w-full">
    <lcontainer class="mb-4">
      <div class="heading flex flex-row items-center justify-between py-2 px-8">
        <div>
          <div class="page text-white">Discussion Boards</div>
        </div>
        <div>
          <img :src="require('../../../assets/tenant_image.png')" alt="" />
        </div>
      </div>
    </lcontainer>
    <div class="">
      <div class="block sm:flex sm:justify-even sm:flex-wrap">
        <card v-for="board in searchBoards" :key="board.id" :board="board" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    lcontainer: () => import("@/components/general/container"),
    card: () => import("@/components/learner/discussionCard"),
  },
  data() {
    return {
      search: "",
      boards: [],
    };
  },
  methods: {
    ...mapActions(["fetchDiscussionBoards"]),
  },
  computed: {
    ...mapGetters(["getTenantSurveys"]),
    searchBoards() {
      return this.boards.filter((board) => {
        return board.title.toLowerCase().match(this.search.toLowerCase());
      });
    },
  },
  async mounted() {
    this.boards = await this.fetchDiscussionBoards();
  },
};
</script>
<style scoped></style>
